app.controller(
    'AdminUserInfosController', ['$scope', '$rootScope', '$http', '$state', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'UserService', '$sce', '$translate', 'AdminService', AdminUserInfosController]
);

function AdminUserInfosController($scope, $rootScope, $http, $state, $stateParams, $timeout, toastr, $document, Configuration, UserService, $sce, $translate, AdminService) {
    var vm = this;

    $rootScope.UserInfos = {
        UserDefaultLang: {},
        RoleList: [{ name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }],
        NewPassword2: '',
        AssociatedZoneList: [{ name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }],
        CurrentRoleText: "Admin",
        User: {
            LangForWork: 'fr',
            LangForTranslationSource: 'fr',
            LangForTranslationDestination: 'en'
        },
    }
    
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.id) {
        vm.ParamUserId = $stateParams.id;
    }
    else {
        vm.ParamUserId = 1;
    }

    $scope.config = {
        setHeight: 500
    };

    initController();

    function initController() {
        getAdminUserInfo(vm.ParamUserId);
    }

    function getAdminUserInfo(userId) {
        AdminService.getAdminUserInfo(userId)
            .then(function (user) {
                $rootScope.UserInfos = user.data;
            });
    }

    vm.UpdateAdminUserInfo = function (userInfos) {
        if (userInfos.NewPassword != null && userInfos.NewPassword2 != null) {
            if (userInfos.NewPassword == userInfos.NewPassword2 && userInfos.NewPassword.length > 0 && userInfos.NewPassword2.length > 0) {

            }
            else {
                alert("Password incorrect");
                return false;
            }
        }
        AdminService.UpdateAdminUserInfo(userInfos)
                                    .then(
                                        function success(data) { },
                                        function error(data) { });
    }

    vm.ResendEmailWelcome = function (userInfos) {
        var emailTitle = $translate.instant("BienvenueEmailTitle", {}, undefined, userInfos.UserLangForInterfaceObj.LangageId);
        AdminService.ResendEmailWelcome(userInfos, emailTitle)
                                    .then(
                                        function success(data) { },
                                        function error(data) { });
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };

    vm.DeleteUser = function (UserInfos) {
        var userToBeDeleted = {
            Id: UserInfos.User.UserId
        }

        AdminService.DeleteUser(userToBeDeleted)
            .then(function (data) {
                $state.go('app.admin-liste-utilisateur');
            });
    }

    $scope.roleLang = [
        {
            name: 'Traducteur',
            openTranslation: true
        },
        {
            name: 'Administrateur',
            openTranslation: false
        },
        {
            name: 'Correcteur',
            openTranslation: false
        },
        {
            name: 'Secrétaire de rédaction',
            openTranslation: false
        }
    ];
}